<template>
  <div class="introduction">
    <div class="topInfo" :class="lan == 'ar' ? 'ar' : ''">
      <img class="logo" src="../assets/images/mlbb_logo.png" alt="" />
      <span class="logoInfo"></span>
      <span class="logo_mcc"></span>
      <div class="lan" @click="openLan">{{ lanText }}</div>
    </div>
    <div class="joinUs" @click="openJoin">
      <img src="../assets/images/join_us.png" alt="" />
      <p v-if="lan !='mm' ">{{ $t("message.strid4") }}</p>
    </div>
    <div class="welcome">
      <img class="slognImg" :src="slognImg" alt="" />
      <div class="joinBtn" :class="{smallFont: lan == 'ph'}" @click="openJoin('join_home1')">{{ $t("message.strid4") }}</div>
      <p class="homeText">
        {{ web_desc }}
      </p>
    </div>

    <div class="benefits">
      <Title :titleText="$t('message.strid36')"></Title>
      <div class="tips">
        <p>{{ $t("message.strid37") }}</p>
      </div>
      <div class="perkList">
        <div class="item">
          <img src="../assets/images/perk1.png" alt="" />
          <p>{{ $t("message.strid38") }}</p>
        </div>
        <div class="item">
          <img src="../assets/images/perk2.png" alt="" />
          <p>{{ $t("message.strid39") }}</p>
        </div>
        <div class="item">
          <img src="../assets/images/perk3.png" alt="" />
          <p>{{ $t("message.strid40") }}</p>
        </div>
      </div>
      <div class="tips moreTips">
        <p>{{ $t("message.strid41") }}</p>
      </div>
      <div class="benefitList">
        <div class="item">
          <img src="../assets/images/offline.png" alt="" />
          <p>{{ $t("message.strid43") }}</p>
        </div>
        <div class="item">
          <img src="../assets/images/brand.png" alt="" />
          <p>{{ $t("message.strid45") }}</p>
        </div>
        <div class="item">
          <img src="../assets/images/Merchandise.png" alt="" />
          <p>{{ $t("message.strid42") }}</p>
        </div>

        <div class="item">
          <img src="../assets/images/skin.png" alt="" />
          <p>{{ $t("message.strid44") }}</p>
        </div>

        <div class="item">
          <img src="../assets/images/spokes.png" alt="" />
          <p>{{ $t("message.strid46") }}</p>
        </div>
        <img
          class="benefit_role"
          src="../assets/images/benefit_role.png"
          alt=""
        />
      </div>
    </div>

    <div class="requirements">
      <Title :titleText="$t('message.strid48')"></Title>
      <div class="require_role"></div>
      <div class="list requireList">
        <div class="list" :class="lan == 'ar' ? 'ar' : ''">
          <p class="text" v-for="item in requirements" :key="item">
            {{ item.content }}
          </p>
        </div>
        <div class="joinBtn" :class="{smallFont: lan == 'ph'}" @click="openJoin('join_home2')">{{ $t("message.strid4") }}</div>
      </div>
    </div>

    <div class="follow">
      <Title :titleText="$t('message.strid49')"></Title>
      <div class="list">
        <div
          class="item"
          v-for="(items, name) in follow_us"
          :key="name"
          :class="lan == 'ar' ? 'ar' : ''"
        >
          <span class="item_title">{{ items[0].platform_title }}</span>
          <a
            class="little_item"
            v-for="(item, index) in items"
            :key="index"
            :href="item.jump_url"
            target="_blank"
          >
            <div
              class="img_box"
              :data-background="require('@/assets/images/img_bg.png')"
            >
              <img v-lazy="interceptFn(item.img)" alt="" />
            </div>
            <p>{{ item.name }}</p>
          </a>
        </div>
      </div>
      <div class="sharelist">
        <a
          :href="item.jump_url"
          v-for="item in share_platform"
          :key="item"
          target="_blank"
        >
          <img v-lazy="item.img" alt="" />
        </a>
      </div>
      <!-- <div class="tips">Check out MLBB official accounts</div> -->
      <img
        class="follow_role"
        src="../assets/images/follow_role.png"
        alt=""
        srcset=""
      />
    </div>
    <Lanbox
      v-if="showlanBox"
      :lan="lan"
      :flag="flag"
      @chose="choseLan"
      @close="closeLan"
    ></Lanbox>

    <Nav :router="'home'" :lan="lan" @open="openJoin"></Nav>
    <joinBox v-if="showJoinBox" :lan="lan" :list="join_us" @close="closeJoin"></joinBox>
  </div>
</template>

<script>
import { getList } from "@/proxy/index";

export default {
  components: {
    Lanbox: () => import("@/components/lanBox"),
    Title: () => import("@/components/Title"),
    Nav: () => import("@/components/nav"),
    joinBox: () => import("@/components/joinBox"),
  },
  data() {
    return {
      showlanBox: false,
      showJoinBox: false,
      languageList: [
        {
          label: "EN",
          value: "en",
        },
        {
          label: "AR",
          value: "ar",
        },
        // {
        //   label: "ES",
        //   value: "es",
        // },
        {
          label: "MM",
          value: "mm",
        },
        {
          label: "MY",
          value: "my",
        },
        {
          label: "KH",
          value: "kh",
        },
        // {
        //   label: "BR",
        //   value: "pt_BR",
        // },
        {
          label: "ZH",
          value: "zh",
        },
        {
          label: "ID",
          value: "id",
        },
        {
          label: "PH",
          value: "ph",
        },
      ],
      lan: "en",
      lanText: "EN",
      follow_us: "",
      join_us: "",
      requirements: "",
      share_platform: "",
      web_desc: "",
      web_h_pic: "",
      web_s_pic: "",
      web_title: "",
      slognImg: "",
    };
  },
  methods: {
    interceptFn (url) {
      return url.split('?')[0] || url
    },
    getParam() {
      getList({ lang: this.lan })
        .then((res) => {
          if (res.code == 0) {
            var data = res.data;
            this.follow_us = data.follow_us;
            this.join_us = data.join_us;
            this.requirements = data.requirements;
            this.share_platform = data.share_platform;
            this.web_desc = data.web_desc;
            this.web_h_pic = data.web_h_pic;
            this.web_s_pic = data.web_s_pic;
            this.web_title = data.web_title;
            this.orient();
          }
        })
        .catch(() => {
          //
          this.orient();
        });
    },
    openLan() {
      this.showlanBox = true;
    },
    closeLan() {
      this.showlanBox = false;
    },
    choseLan(name, value) {
      this.lan = name;
      this.lanText = value;
      this.$i18n.locale = name;
      this.showlanBox = false;
      this.getParam();
      window.localStorage.setItem("Creatorlang", this.lan);
    },
    openJoin(type) {
      this.$mlog.visitLog({
        behavior: "click",
        type: type ? type : 'join_nav'
      })
      this.showJoinBox = true;
    },
    closeJoin() {
      this.showJoinBox = false;
    },
    orient() {
      this.slognImg = this.web_h_pic;
      if (window.orientation === 180 || window.orientation === 0) {
        this.orientation = false;
        this.slognImg = this.web_s_pic;
      }
      if (window.orientation === 90 || window.orientation === -90) {
        this.orientation = true;
        this.slognImg = this.web_h_pic;
      }
    },
  },
  mounted() {
    if (this.$route.query.lang) {
      const i = this.languageList.find(
        (item) => item.value == this.$route.query.lang
      );
      if (i) {
        this.lan = i.value;
        this.$i18n.locale = i.value;
        this.lanText = i.label;
        window.localStorage.setItem("Creatorlang", this.lan);
      }
      this.$router.push({ query: {} });
    } else {
      this.lan = "en";
      this.$i18n.locale = "en";
    }
    const lang = window.localStorage.getItem("Creatorlang");
    if (lang) {
      const i = this.languageList.find((item) => item.value == lang);
      if (i) {
        this.lan = i.value;
        this.$i18n.locale = i.value;
        this.lanText = i.label;
      }
    } else {
      this.lan = "en";
      this.$i18n.locale = "en";
      window.localStorage.setItem("Creatorlang", this.lan);
    }
    this.getParam();

    window.addEventListener("orientationchange", this.orient, false);
  },
};
// };
</script>

<style lang="scss" scoped>
@import "@/assets/style/introduction.scss";
</style>
